import React from 'react';
import { useTranslation } from 'react-i18next';
import { BusinessPageCardsItems } from './BusinessPageCards';
import * as S from './BusinessPageCards.styles';
import { ROUTES } from '@/constants/routes';
import { withAppFlag } from '@/hooks/useDefaultLiteWebView';

const cardItems = [
  'price',
  'discount',
  'support',
  'service',
  'users',
  'view',
  'partners',
  'categories',
];

interface BusinessPageCardsProps {
  isLite: boolean;
}

export const BusinessPageCards: React.FC<BusinessPageCardsProps> = ({
  isLite,
}) => {
  const { t } = useTranslation();

  return (
    <S.BusinessPageCardsSection>
      <S.BusinessPageCardsTitle>
        {t('business.advantages')}
      </S.BusinessPageCardsTitle>
      <S.BusinessPageItems>
        <S.BusinessPageCardsContainer>
          <S.BusinessPageCards $isLite={isLite}>
            {cardItems.map(item => (
              <BusinessPageCardsItems key={item} item={item} />
            ))}
          </S.BusinessPageCards>
        </S.BusinessPageCardsContainer>
      </S.BusinessPageItems>
      <S.BusinessPageCardsButton
        href={withAppFlag(ROUTES.businessMediakit, isLite)}
        target={isLite ? '_self' : '_blank'}
        data-stat="landing-link-mediakit"
      >
        {t('business.download')}
      </S.BusinessPageCardsButton>
    </S.BusinessPageCardsSection>
  );
};

BusinessPageCards.displayName = 'BusinessPageCards';
